import { ApiClient, ApiClientProps, Paginated } from './client';

export type OrgMember = {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  joined_at: string;
};

export class OrgMembersClient extends ApiClient {
  constructor(props: ApiClientProps) {
    super(props);
  }

  list = async (orgId: number) => {
    return this._get<Paginated<OrgMember>>(`organizations/${orgId}/members/`);
  };

  updateRole = async (orgId: number, memberId: number, role: string) => {
    return this._patch<OrgMember>(`organizations/${orgId}/members/${memberId}/`, { role });
  };

  remove = async (orgId: number, memberId: number) => {
    return this._delete(`organizations/${orgId}/members/${memberId}/`);
  };
}
